export default __webpack_public_path__ + "icon_get_direction.97981404ed12d5ec7db28cc5e0be3c63.svg";